import React from 'react';
import { CheckIcon } from 'lucide-react';
import { solutionPoints } from '../data/content';
export function Solution() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-167" data-mp="1ek2p7swds9x4">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-168" data-mp="10tpi1srbcz8u">
        <h2 className="mx-auto max-w-4xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-169" data-mp="10r39pqwlmfpk">
          Todo lo que necesitas para estudiar Terapia Intravenosa, organizado en un único sistema visual
        </h2>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-170" data-mp="vuctn3ksnk45">
          {solutionPoints.map(point => {
          const [lead, ...rest] = point.split(':');
          return <li key={point} className="flex items-start gap-3" data-id="element-171" data-mp="mug4z1yeml93">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-900 text-white" data-id="element-172" data-mp="2c8mazdqmc8lh">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="2h6ecmzh2f92v" />
                </span>
                <span className="text-slate-900" data-id="element-174" data-mp="6zyyutgx5kw7">
                  <strong className="font-bold" data-id="element-175" data-mp="6ye0stvebjtl">{lead}:</strong>
                  <span className="text-slate-600" data-id="element-176" data-mp="2ydnxdny3gon">{rest.join(':')}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}